import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConfigProvider } from "antd";
import { toast } from "react-toastify";

import {
  UpdateDeviceID,
  UpdateMeterID,
  UpdatealertType,
  handleloading
} from "../../Store/Redux/Reducers/Dashboardreducers";
import {
  CatchMessage,
  HandleDeviceId,
  HandleMeterId,
  JSONtoformdata,
  tokenisValid
} from "../../Shared/Methods";
import { DropdownService } from "../../Services/ApiServices";
import { HandleSessionModal } from "../../Store/Redux/Reducers/Authreducers";
import Commonselectfield from "../CommonForms/CommonSelectField";
import { useLocation } from "react-router-dom";

function Commondevicedropdown({
  handleDashboardData
}: {
  handleDashboardData: (id1: any, id2: any) => void;
}) {
  const { LoginData } = useSelector((state: any) => state.Auth);
  const [DropDowns, setDropDowns] = useState<any>({
    DeviceCode: [],
    Meter: []
  });
  const dispatch = useDispatch();
  const DevicesSessionCode: any = sessionStorage.getItem("DeviceCode");
  const MeterSessionCode: any = sessionStorage.getItem("MeterCode");
  const renderondeviceID = HandleDeviceId();
  const renderonmeterID = HandleMeterId();
  let { pathname } = useLocation();

  useEffect(() => {
    if (
      LoginData !== null &&
      renderondeviceID?.deviceId &&
      renderonmeterID?.meter_id &&
      pathname !== "/dashboard"
    ) {
      handleDashboardData(renderondeviceID, renderonmeterID);
    }
  }, [LoginData, renderondeviceID?.deviceId, renderonmeterID?.meter_id]);

  useEffect(() => {
    if (LoginData !== null) {
      getForTypeDropDown();
    }
  }, [LoginData]);

  // useEffect(() => {
  //   if (LoginData !== null && DevicesSessionCode) {
  //     getMeterDropDown(DevicesSessionCode);
  //   }
  // }, [LoginData, DevicesSessionCode]);

  const getForTypeDropDown = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token
    };

    DropdownService(JSONtoformdata(finalObj), "dropDownDeviceCode")
      .then(async (res) => {
        if (res?.data?.status === 1) {
          const ForType = res.data.data.map((ele: any, ind: number) => {
            return { value: ele?.deviceId, label: ele?.deviceCode };
          });

          setDropDowns((pre: any) => {
            return {
              ...pre,
              DeviceCode: ForType
            };
          });

          if (!DevicesSessionCode) {
            ForType?.find((ele: any, ind: number) => {
              if (ind === 0) {
                sessionStorage.setItem("DeviceCode", ele?.value);
                getMeterDropDown(ele?.value, false);
              }
            });
          } else if (res?.data?.data?.length == 0) {
            sessionStorage.setItem("DeviceCode", "");
            dispatch(UpdateDeviceID("dsd"));
          } else if (res?.data?.data?.length > 0) {
            getMeterDropDown(DevicesSessionCode, false);
          }
        } else if (res?.data?.status === 0) {
          sessionStorage.setItem("DeviceCode", "");
          sessionStorage.setItem("MeterCode", "");
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          sessionStorage.setItem("DeviceCode", "");
          sessionStorage.setItem("MeterCode", "");
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        CatchMessage(err);
        sessionStorage.setItem("DeviceCode", "");
        sessionStorage.setItem("MeterCode", "");
      })
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const getMeterDropDown = (deviceid = "", setfirstobject = false) => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      device_id: deviceid
    };
    DropdownService(JSONtoformdata(finalObj), "meterDropdown")
      .then(async (res) => {
        if (res?.data?.status === 1) {
          setDropDowns((pre: any) => {
            return {
              ...pre,
              Meter: res.data.data
            };
          });

          if (!MeterSessionCode) {
            res.data.data?.find((ele: any, ind: number) => {
              if (ind === 0) {
                sessionStorage.setItem("MeterCode", ele?.id);
                dispatch(UpdateMeterID("dummy"));
              }
            });
            sessionStorage.setItem("DeviceCode", deviceid ? deviceid : "");
            dispatch(UpdateDeviceID("sd"));
          } else if (setfirstobject && res.data.data?.length > 0) {
            sessionStorage.setItem("DeviceCode", deviceid ? deviceid : "");
            res.data.data?.find((ele: any, ind: number) => {
              if (ind === 0) {
                sessionStorage.setItem("MeterCode", ele?.id);
                dispatch(UpdateMeterID("dummy"));
              }
            });
          } else if (res.data.data?.length == 0) {
            sessionStorage.setItem("MeterCode", "");
            sessionStorage.setItem("DeviceCode", deviceid ? deviceid : "");
            dispatch(UpdateMeterID("dummy"));
          } else if (res.data.data?.length > 0) {
            res.data.data?.find((ele: any, ind: number) => {
              if (ele?.id === MeterSessionCode) {
                sessionStorage.setItem("MeterCode", ele?.id);
                dispatch(UpdateMeterID(ele?.id));
              }
            });
            sessionStorage.setItem("DeviceCode", deviceid ? deviceid : "");
            dispatch(UpdateDeviceID("dummy"));
          }
        } else if (res?.data?.status === 0) {
          sessionStorage.setItem("MeterCode", "");

          const istokenValid = await tokenisValid(LoginData?.token);

          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          sessionStorage.setItem("MeterCode", "");

          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        CatchMessage(err);
        sessionStorage.setItem("MeterCode", "");
      })
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  return (
    <>
      <div style={{ display: "flex", gap: "5px" }}>
        <ConfigProvider
          theme={{
            token: {
              colorBorder: "#20a2a099",
              colorPrimaryHover: "#20a2a0",
              colorInfoBorderHover: "#FFDA3F"
            }
          }}
        >
          <Commonselectfield
            value={
              DevicesSessionCode ? parseInt(DevicesSessionCode) : undefined
              // DevicesSessionCode
              //   ? DropDowns?.DeviceCode?.find((ele: any) => {
              //       return ele?.deviceId === parseInt(DevicesSessionCode);
              //     })?.deviceId
              //   : undefined
            }
            onChange={(value: any) => {
              dispatch(UpdatealertType(null));

              getMeterDropDown(value, true);
            }}
            options={DropDowns?.DeviceCode}
            labelname="Device Code"
            style={{ width: "170px" }}
            size="middle"
            className="HeaderSelectDropdown"
            nolabel={true}
            allowClear={false}
            zIndex={10507987}
          />
          <Commonselectfield
            value={MeterSessionCode ? parseInt(MeterSessionCode) : undefined}
            onChange={(value: any) => {
              dispatch(UpdatealertType(null));
              sessionStorage.setItem("MeterCode", value ? value : "");
              dispatch(UpdateMeterID(value));
            }}
            options={DropDowns?.Meter?.map((ele: any) => {
              return {
                label: ele?.meter_name,
                value: ele?.id,
                disabled: ele?.subscription_status !== 1,
                title:
                  ele?.subscription_status !== 1
                    ? "Not Subscribed"
                    : ele?.meter_name
              };
            })}
            labelname="Meter"
            style={{ width: "170px" }}
            size="middle"
            className="HeaderSelectDropdown"
            nolabel={true}
            allowClear={false}
            zIndex={10507987}
          />
        </ConfigProvider>
      </div>
    </>
  );
}

export default Commondevicedropdown;
